import * as c from './constants';

const INIT_STATE = {}

const INIT_STATE_SECTION_TABLE = {
  isLoading: false,
  isError: false,
  message: '',
  meta: {
    total: 0,
    limit: 1,
    skip: 10,
  },
  data: []
}

export default function(state = INIT_STATE, action) {
  const { type, key } = action;

  switch (type) {
    case c.SECTION_TABLE_INITIALIZE:
      return {
        ...state,
        [key]: sectionTable(state[key], action)
      };

    case c.SECTION_TABLE_DESTROY:
      const { [key]: destroy, ...newState } = state;
      return newState;

    case c.SECTION_TABLE_SET_DATA:
      return {
        ...state,
        [key]: sectionTable(state[key], action)
      };

    case c.SECTION_TABLE_SET_LOADER:
      return {
        ...state,
        [key]: sectionTable(state[key], action)
      };

    case c.SECTION_TABLE_SET_ERROR:
      return {
        ...state,
        [key]: sectionTable(state[key], action)
      };

    default: 
      return state;
  }
}

function sectionTable(state = INIT_STATE_SECTION_TABLE, action) {
  const { payload } = action;

  switch (action.type) {
    case c.SECTION_TABLE_INITIALIZE:
      return INIT_STATE_SECTION_TABLE;

    case c.SECTION_TABLE_SET_DATA:
      return {
        ...INIT_STATE_SECTION_TABLE,
        meta: payload.meta,
        data: payload.data,
      }

    case c.SECTION_TABLE_SET_LOADER:
      return {
        ...state,
        isError: false,
        message: '',
        isLoading: payload,
      }

    case c.SECTION_TABLE_SET_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: payload.isError,
        message: payload.message
      }

    default:
      return state;
  }
}